import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 11.9961H18",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 18L6 12L12 6",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full flex"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "m-auto" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "animate-spin h-10 w-10 text-white",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col py-5 px-4 justify-center space-y-4"
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col space-y-1"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-white font-medium text-lg" }, "When...", -1)
const _hoisted_8 = { class: "flex flex-col space-y-2" }
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col space-y-1"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-white font-medium text-lg" }, "When...", -1)
const _hoisted_11 = { class: "flex flex-col space-y-2" }
const _hoisted_12 = {
  key: 2,
  class: "flex flex-col space-y-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-white font-medium text-lg" }, "When...", -1)
const _hoisted_14 = { class: "flex flex-col space-y-2" }

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader, IonLabel,
  IonPage, IonSegment, IonSegmentButton,
  IonTitle,
  IonToolbar, onIonViewDidEnter,
  onIonViewWillEnter,
  useIonRouter,
} from '@ionic/vue';
import {defineComponent, inject, onMounted, reactive, Ref, ref, watch} from 'vue';
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {UserInterface} from "@/interfaces/UserInterface";
import InputCheckbox from "@/components/InputCheckbox.vue";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {AccountType} from "@/definitions/AccountType";



export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSettingsAccounNotifications',
  setup(__props) {

const user: Ref<UserInterface | undefined> = inject('user') as Ref<UserInterface | undefined>
const loading = ref(true)
const ionRouter = useIonRouter()

const busy = ref(false)
const errors = ref({})

const preferences: any = reactive({
  notifyWhenSomebodyLikesMyPost: [true],
  notifyWhenSomebodyLikesMyComment: [true],
  notifyWhenSomebodyRepliesToMyPost: [true],
  notifyWhenSomebodyRepliesToMyComment: [true],
  notifyWhenSomebodyMentionsMe: [true],
  notifyWhenSomebodySendsAFriendRequest: [true],
  notifyWhenSomebodyStartsFollowingMe: [true],
  notifyWhenSomebodyAcceptsYourFriendRequest: [true],
  notifyWhenSomebodyWinksAtMe: [true],
  notifyWhenSomebodyAttends: [true],
  notifyWhenSomebodyShowsInterest: [true],
  notifyWhenSomebodyRequestsAnInvite: [true],
  notifyWhenSomebodyReviewsMyProfile: [true],
  notifyWhenSomebodyCommentsOnMyEvent: [true],
  notifyWhenSomebodyRepliesToCommentOnEvent: [true]
})

onMounted(async () => {
  const userPreferences = (await ApiService.User().get()).preferences
  preferences.notifyWhenSomebodyLikesMyPost = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyLikesMyPost]))]
  preferences.notifyWhenSomebodyLikesMyComment = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyLikesMyComment]))]
  preferences.notifyWhenSomebodyRepliesToMyPost = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyRepliesToMyPost]))]
  preferences.notifyWhenSomebodyRepliesToMyComment = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyRepliesToMyComment]))]
  preferences.notifyWhenSomebodyMentionsMe = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyMentionsMe]))]
  preferences.notifyWhenSomebodySendsAFriendRequest = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodySendsAFriendRequest]))]
  preferences.notifyWhenSomebodyStartsFollowingMe = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyStartsFollowingMe]))]
  preferences.notifyWhenSomebodyAcceptsYourFriendRequest = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyAcceptsYourFriendRequest]))]
  preferences.notifyWhenSomebodyWinksAtMe = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyWinksAtMe]))]
  preferences.notifyWhenSomebodyAttends = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyAttends]))]
  preferences.notifyWhenSomebodyShowsInterest = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyShowsInterest]))]
  preferences.notifyWhenSomebodyRequestsAnInvite = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyRequestsAnInvite]))]
  preferences.notifyWhenSomebodyAcceptsAnInvite = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyAcceptsAnInvite]))]
  preferences.notifyWhenSomebodyReviewsMyProfile = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyReviewsMyProfile]))]
  preferences.notifyWhenSomebodyCommentsOnMyEvent = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyCommentsOnMyEvent]))]
  preferences.notifyWhenSomebodyRepliesToCommentOnEvent = [Boolean(Number(userPreferences[PreferenceKey.NotifyWhenSomebodyRepliesToCommentOnEvent]))]

  loading.value = false
})

watch(() => ({...preferences}), async (preference, previousPreference) => {

  if (previousPreference.notifyWhenSomebodyLikesMyPost[0] !== preference.notifyWhenSomebodyLikesMyPost[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyLikesMyPost, preference.notifyWhenSomebodyLikesMyPost[0])
  }

  if (previousPreference.notifyWhenSomebodyLikesMyComment[0] !== preference.notifyWhenSomebodyLikesMyComment[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyLikesMyComment, preference.notifyWhenSomebodyLikesMyComment[0])
  }

  if (previousPreference.notifyWhenSomebodyRepliesToMyComment[0] !== preference.notifyWhenSomebodyRepliesToMyComment[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyRepliesToMyComment, preference.notifyWhenSomebodyRepliesToMyComment[0])
  }

  if (previousPreference.notifyWhenSomebodyRepliesToMyPost[0] !== preference.notifyWhenSomebodyRepliesToMyPost[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyRepliesToMyPost, preference.notifyWhenSomebodyRepliesToMyPost[0])
  }

  if (previousPreference.notifyWhenSomebodyMentionsMe[0] !== preference.notifyWhenSomebodyMentionsMe[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyMentionsMe, preference.notifyWhenSomebodyMentionsMe[0])
  }

  if (previousPreference.notifyWhenSomebodySendsAFriendRequest[0] !== preference.notifyWhenSomebodySendsAFriendRequest[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodySendsAFriendRequest, preference.notifyWhenSomebodySendsAFriendRequest[0])
  }

  if (previousPreference.notifyWhenSomebodyAcceptsYourFriendRequest[0] !== preference.notifyWhenSomebodyAcceptsYourFriendRequest[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyAcceptsYourFriendRequest, preference.notifyWhenSomebodyAcceptsYourFriendRequest[0])
  }

  if (previousPreference.notifyWhenSomebodyStartsFollowingMe[0] !== preference.notifyWhenSomebodyStartsFollowingMe[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyStartsFollowingMe, preference.notifyWhenSomebodyStartsFollowingMe[0])
  }

  if (previousPreference.notifyWhenSomebodyWinksAtMe[0] !== preference.notifyWhenSomebodyWinksAtMe[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyWinksAtMe, preference.notifyWhenSomebodyWinksAtMe[0])
  }

  if (previousPreference.notifyWhenSomebodyAttends[0] !== preference.notifyWhenSomebodyAttends[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyAttends, preference.notifyWhenSomebodyAttends[0])
  }

  if (previousPreference.notifyWhenSomebodyShowsInterest[0] !== preference.notifyWhenSomebodyShowsInterest[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyShowsInterest, preference.notifyWhenSomebodyShowsInterest[0])
  }

  if (previousPreference.notifyWhenSomebodyRequestsAnInvite[0] !== preference.notifyWhenSomebodyRequestsAnInvite[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyRequestsAnInvite, preference.notifyWhenSomebodyRequestsAnInvite[0])
  }

  if (previousPreference.notifyWhenSomebodyAcceptsAnInvite[0] !== preference.notifyWhenSomebodyAcceptsAnInvite[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyAcceptsAnInvite, preference.notifyWhenSomebodyAcceptsAnInvite[0])
  }

  if (previousPreference.notifyWhenSomebodyReviewsMyProfile[0] !== preference.notifyWhenSomebodyReviewsMyProfile[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyReviewsMyProfile, preference.notifyWhenSomebodyReviewsMyProfile[0])
  }

  if (previousPreference.notifyWhenSomebodyReviewsMyProfile[0] !== preference.notifyWhenSomebodyReviewsMyProfile[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyReviewsMyProfile, preference.notifyWhenSomebodyReviewsMyProfile[0])
  }

  if (previousPreference.notifyWhenSomebodyReviewsMyProfile[0] !== preference.notifyWhenSomebodyReviewsMyProfile[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyReviewsMyProfile, preference.notifyWhenSomebodyReviewsMyProfile[0])
  }

  if (previousPreference.notifyWhenSomebodyCommentsOnMyEvent[0] !== preference.notifyWhenSomebodyCommentsOnMyEvent[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyCommentsOnMyEvent, preference.notifyWhenSomebodyCommentsOnMyEvent[0])
  }

  if (previousPreference.notifyWhenSomebodyRepliesToCommentOnEvent[0] !== preference.notifyWhenSomebodyRepliesToCommentOnEvent[0]) {
    await ApiService.User().setPreference(PreferenceKey.NotifyWhenSomebodyRepliesToCommentOnEvent, preference.notifyWhenSomebodyRepliesToCommentOnEvent[0])
  }

}, {deep: true})


const goBack = async () => {
  if (busy.value) return
  await ionRouter.back()
}

const tab = ref('feed')
const setTab = async (ev: any) => {
  tab.value = ev.detail.value
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "text-white font-medium text-2xl" }, {
                default: _withCtx(() => [
                  _createTextVNode("Notifications")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "flex w-full h-full" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSegment), {
            value: tab.value,
            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (setTab($event))),
            class: "relative z-40 backdrop-blur-2xl bg-opacity-40 ml-0 w-full sticky top-0",
            "swipe-gesture": false,
            mode: "ios"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSegmentButton), { value: "feed" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Feed ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "events" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Events ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "profile" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Profile ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (tab.value === 'events')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyAttends,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((preferences.notifyWhenSomebodyAttends) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody attends',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyShowsInterest,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((preferences.notifyWhenSomebodyShowsInterest) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody shows interest',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyRequestsAnInvite,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((preferences.notifyWhenSomebodyRequestsAnInvite) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody requests an invite',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyCommentsOnMyEvent,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((preferences.notifyWhenSomebodyCommentsOnMyEvent) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody comments on your event',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyRepliesToCommentOnEvent,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((preferences.notifyWhenSomebodyRepliesToCommentOnEvent) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody replies to a comment',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyAcceptsAnInvite,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((preferences.notifyWhenSomebodyAcceptsAnInvite) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Your invite request is accepted or rejected',
              value: true
            }
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (tab.value === 'profile')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyWinksAtMe,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((preferences.notifyWhenSomebodyWinksAtMe) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody winks at me',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodySendsAFriendRequest,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((preferences.notifyWhenSomebodySendsAFriendRequest) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody sends a friend request',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyStartsFollowingMe,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((preferences.notifyWhenSomebodyStartsFollowingMe) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody starts following me',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyAcceptsYourFriendRequest,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((preferences.notifyWhenSomebodyAcceptsYourFriendRequest) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody accepts your friend request',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyReviewsMyProfile,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((preferences.notifyWhenSomebodyReviewsMyProfile) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody reviews your profile',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyMentionsMe,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((preferences.notifyWhenSomebodyMentionsMe) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody mentions me',
              value: true
            }
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (tab.value === 'feed')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyLikesMyPost,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((preferences.notifyWhenSomebodyLikesMyPost) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody likes my post',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyLikesMyComment,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((preferences.notifyWhenSomebodyLikesMyComment) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody likes my comment',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyRepliesToMyPost,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((preferences.notifyWhenSomebodyRepliesToMyPost) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody replies to my post',
              value: true
            }
                        }, null, 8, ["modelValue"]),
                        _createVNode(InputCheckbox, {
                          name: "display",
                          modelValue: preferences.notifyWhenSomebodyRepliesToMyComment,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((preferences.notifyWhenSomebodyRepliesToMyComment) = $event)),
                          "input-type": "toggle",
                          option: {
              text: 'Somebody replies to my comment',
              value: true
            }
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})